// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k9-3";
export var downloadButton = "_k9-4";
export var fileContainer = "_k9-9 _k9-7";
export var fileContainerBase = "_k9-7";
export var fileContainerFixedHeight = "_k9-8 _k9-7";
export var fileInfo = "_k9-5";
export var fileInfoWidthRestricted = "_k9-6";
export var fileType = "_k9-1";
export var fileTypeName = "_k9-2";
export var image = "_k9-0";
export var link = "_k9-b";
export var overflowEllipsis = "_k9-a";